import React from 'react';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-[#F5F5DC] pt-40 pb-20 px-6 max-w-3xl mx-auto text-left font-sans text-[#2C1E12]">
      <h2 className="text-3xl font-serif uppercase tracking-wider mb-2">Contact Us</h2>
      <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-8 border-b border-[#2C1E12]/10 pb-4">Customer Care Desk & Escalation Pipeline</p>
      
      <div className="space-y-6 text-sm leading-relaxed font-serif">
        <div className="bg-white border border-[#E5D3B3]/60 p-6 space-y-4 rounded-sm font-mono text-xs shadow-xs">
          <div>
            <span className="text-zinc-400 block text-[9px] uppercase tracking-wider mb-0.5">📞 Direct Helpline Voice Network</span>
            <span className="text-sm font-sans font-black text-[#2C1E12]">+91 7987274057</span>
          </div>
          <div>
            <span className="text-zinc-400 block text-[9px] uppercase tracking-wider mb-0.5">✉️ Managed Help Desk Email</span>
            <a href="mailto:modischekledings@gmail.com" className="text-sm font-sans font-bold text-red-950 underline hover:text-red-900">modischekledings@gmail.com</a>
          </div>
          <div>
            <span className="text-zinc-400 block text-[9px] uppercase tracking-wider mb-0.5">📍 Registered Office & Corporate Headquarters</span>
            <span className="text-sm font-sans text-zinc-700 leading-relaxed block mt-1 font-bold">
              15-345, RAM RAHIM COLONY BEHIND PAPAYA TREE, RAU, INDORE, MADHYA PRADESH, PIN: 453331
            </span>
          </div>
        </div>
        <p className="text-xs text-zinc-500 italic mt-4">Our support desk operates between 10:00 AM to 6:00 PM IST, Monday through Saturday. Digital messages are processed sequentially within 24 business hours.</p>
      </div>
    </div>
  );
};

export default ContactPage;